import { memo } from 'react';

type CurrencyType = 'TRY' | 'USD' | 'EUR' | 'GBP';

interface CurrencyCellProps {
  value: number | null | undefined;
  currency?: CurrencyType;
  decimals?: number;
  colorCoded?: boolean;
  locale?: string;
}

const CURRENCY_SYMBOLS: Record<CurrencyType, string> = {
  TRY: '₺',
  USD: '$',
  EUR: '€',
  GBP: '£'
};

export const CurrencyCell = memo(({
  value,
  currency = 'TRY',
  decimals = 2,
  colorCoded = false,
  locale = 'tr-TR'
}: CurrencyCellProps) => {
  if (value === null || value === undefined) {
    return <span style={{ color: 'var(--color-text-muted)' }}>—</span>;
  }

  const formattedValue = Math.abs(value).toLocaleString(locale, {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals
  });

  const symbol = CURRENCY_SYMBOLS[currency];
  const isNegative = value < 0;

  const color = colorCoded
    ? value > 0
      ? 'var(--color-positive)'
      : value < 0
        ? 'var(--color-negative)'
        : 'var(--color-text-primary)'
    : 'var(--color-text-primary)';

  return (
    <span
      style={{
        fontFamily: 'var(--font-mono)',
        fontVariantNumeric: 'tabular-nums',
        color,
        fontSize: '13px',
        display: 'inline-flex',
        alignItems: 'center',
        gap: '2px'
      }}
    >
      {isNegative && <span>−</span>}
      <span style={{ opacity: 0.7, fontSize: '11px' }}>{symbol}</span>
      <span>{formattedValue}</span>
    </span>
  );
});

CurrencyCell.displayName = 'CurrencyCell';
